export const QA_NAME_VIEWING_DATE_TILE = 'viewingDateTile'
